






import Vue from "vue";
import { Location } from "vue-router";
import { onTtBackAction } from "@tt-app/utils";
import {
  Session,
  TerratalkLiveGetterNames,
  TerratalkLiveNamespace
} from "@tt-app/store/terratalkLive/types";

import IconBack from "@joyz/app-core/assets/icons/black/Back.svg";

interface Methods {
  onBackBtnClick: () => void;
}

interface Computed {
  session: Session;
}

interface Props {
  icon: string;
  fallback?: Location;
}

export default Vue.extend<{}, Methods, Computed, Props>({
  name: "TtBackBtn",
  components: {},

  props: {
    icon: { type: String, default: IconBack },
    fallback: { type: Object as () => Location, default: undefined }
  },

  data: function() {
    return {};
  },

  computed: {
    session() {
      return this.$store.getters[
        `${TerratalkLiveNamespace}/${TerratalkLiveGetterNames.ACTIVE_SESSION}`
      ];
    }
  },

  methods: {
    onBackBtnClick() {
      const ttLiveSessionActive = !!this.session;

      onTtBackAction(this.$router, ttLiveSessionActive, this.fallback);
    }
  }
});
